import React from 'react';

const ETicketsIconInverted = ({ size = '25px', color = '#fff' }) => {
  return (
    <svg
      id="b"
      data-name="Capa 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 271.38 185.22"
      width={size} 
      height={size} 
    >
      <g id="c" data-name="b">
        <path
          d="M262.62,63.41c5.19-1.56,8.76-6.32,8.76-11.74v-17.36c0-18.95-15.36-34.31-34.31-34.31h-51.18v24.9c0,4.44-3.6,8.04-8.04,8.04s-8.04-3.6-8.04-8.04V0H34.31C15.36,0,0,15.36,0,34.31v17.36c0,5.42,3.56,10.18,8.76,11.74,12.56,3.76,21.72,15.41,21.72,29.2s-9.16,25.43-21.72,29.2c-5.2,1.56-8.76,6.32-8.76,11.74v17.36c0,18.95,15.36,34.31,34.31,34.31h135.49v-24.9c0-4.44,3.6-8.04,8.04-8.04,2.22,0,4.23.9,5.69,2.35,1.45,1.46,2.35,3.47,2.35,5.69v24.9h51.19c18.95,0,34.31-15.36,34.31-34.31v-17.36c0-5.42-3.57-10.18-8.76-11.74-12.56-3.76-21.72-15.41-21.72-29.2s9.15-25.43,21.72-29.2ZM185.88,126.4c0,4.44-3.6,8.04-8.04,8.04s-8.04-3.6-8.04-8.04v-16.84c0-4.44,3.6-8.04,8.04-8.04,2.22,0,4.23.9,5.68,2.36,1.45,1.45,2.35,3.46,2.35,5.68v16.84ZM185.88,75.65c0,4.44-3.6,8.04-8.04,8.04s-8.04-3.6-8.04-8.04v-16.84c0-4.44,3.6-8.04,8.04-8.04,2.22,0,4.23.9,5.68,2.35,1.45,1.45,2.35,3.46,2.35,5.68v16.84Z"
          fill={color} 
        />
      </g>
    </svg>
  );
};

export default ETicketsIconInverted;
